import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
// import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';


const IISC2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/IISC/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/IISC/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/IISC/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/IISC/4.webp`;
const p5 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/IISC/5.webp`;
const p6 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/IISC/6.webp`;




  

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}




  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
     EDUCATIONAL VISIT: INDIAN INSTITUTE OF SCIENCE
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: 11     Date: 07 March 2026

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Tell me and I forget, teach me and I may remember, involve me and I learn. – Benjamin Franklin”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       On Saturday, 07 March 2026, Class 11 students attended the IISc Open Day 2026 which was organised under the theme ‘Green Open Day’. The event showcased sustainability and technological advancement through interactive science demonstrations, public lectures, and poster presentations. Students explored advanced laboratories, viewed the Biochemistry Centenary Exhibition, and engaged with exhibits on artificial intelligence and fascinating Physics demonstrations such as levitation and plasma balls, gaining valuable exposure to real-world scientific innovation.
        <br></br>
        Students also attended a short presentation where experts spoke about research opportunities, higher education, and careers in Science and engineering. The session was interactive and students were encouraged to ask questions.
        <br></br>

        </Typography>
      </Box>    
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “To raise new questions, new possibilities, to regard old problems from a new angle, requires creative imagination and marks real advance in science.”


<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 250 : 350}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default IISC2025;